import { BrowserRouter, Route } from 'react-router-dom'
import './App.css'
import Header from './components/Header'
import HomePage from './Pages/HomePage'
import CoinPage from './Pages/CoinPage'
import CategoriesPage from './Pages/CategoriesPage'
import CategoryPage from './Pages/CategoryPage'
import { makeStyles } from '@material-ui/core'
import Alert from './components/Alert'

const useStyles = makeStyles(() => ({
  App: {
    backgroundColor: '#14161a',
    color: 'white',
    minHeight: '100vh',
  },
}))

function App() {
  const classes = useStyles()

  return (
    <BrowserRouter>
      <div className={classes.App}>
        <Header />
        <Route path='/' component={HomePage} exact />
        <Route path='/coins/:id' component={CoinPage} />
        <Route path='/categories' component={CategoriesPage} />
        <Route path='/categories/:id' component={CategoryPage} />
      </div>
      <Alert />
    </BrowserRouter>
  )
}

export default App
